import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M8.71115 2.95967C9.00522 2.37152 9.60636 2 10.2639 2C11.2227 2 12 2.77726 12 3.73607V3.83333C12 4.26288 11.875 4.66323 11.6594 5H12.5C13.3284 5 14 5.67157 14 6.5V12.5C14 13.3284 13.3284 14 12.5 14H3.5C2.67157 14 2 13.3284 2 12.5V6.5C2 5.67157 2.67157 5 3.5 5H4.34061C4.125 4.66323 4 4.26288 4 3.83333V3.73607C4 2.77726 4.77726 2 5.73607 2C6.39364 2 6.99478 2.37152 7.28885 2.95967L8 4.38197L8.71115 2.95967ZM8.80902 6H8H7.19098H6.16667H3.5C3.22386 6 3 6.22386 3 6.5V12.5C3 12.7761 3.22386 13 3.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6.5C13 6.22386 12.7761 6 12.5 6H9.83333H8.80902ZM7.19098 5L6.39443 3.40689C6.26974 3.15752 6.01487 3 5.73607 3C5.32955 3 5 3.32955 5 3.73607V3.83333C5 4.47767 5.52233 5 6.16667 5H7.19098ZM11 3.83333C11 4.47767 10.4777 5 9.83333 5H8.80902L9.60557 3.40689C9.73026 3.15752 9.98513 3 10.2639 3C10.6705 3 11 3.32955 11 3.73607V3.83333Z"
            fill="currentColor"
            fillRule="evenodd"
        />
        <path d="M6.5 6V13" stroke="currentColor" />
        <line stroke="currentColor" x1="3" x2="13" y1="8.5" y2="8.5" />
    </svg>
);

export default Icon;
